import { render, staticRenderFns } from "./SelectActivity.vue?vue&type=template&id=450e670f"
import script from "./SelectActivity.vue?vue&type=script&lang=ts"
export * from "./SelectActivity.vue?vue&type=script&lang=ts"
import style0 from "./SelectActivity.vue?vue&type=style&index=0&id=450e670f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports